import styles from './RawHTML.module.scss';

interface RawHTMLProps {
  html: string;
  className?: string;
}

export default function RawHTML({ html, className }: RawHTMLProps) {
  if (!html) return null;
  return (
    <div
      className={`overflow-hidden break-words ${styles.articleContent} ${className ?? ''}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
